import React, { useState } from "react";

import AdCard from "../AdCard";
import ArticleCard from "./ArticleCard";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import LazyLoad from "../../../lib/LazyLoad";
import { Waypoint } from "react-waypoint";
import { makeStyles } from "@material-ui/core/styles";
import useTranslation from "next-translate/useTranslation";
import { TheCycleverseTheme } from "src/theme";
import ButtonLink from "src/components/Navigation/ButtonLink";
import { useRouter } from "next/router";
import { CycleverseNoContentComp } from "src/components/CycleverseNoContent";

const useStyles = makeStyles((theme: TheCycleverseTheme) => ({
  root: {
    flexGrow: 1,
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.globalMarginDesktop,
      marginRight: theme.globalMarginDesktop,
    },
    [theme.breakpoints.down("xs")]: {
      marginLeft: theme.globalMarginMobile,
      marginRight: theme.globalMarginMobile,
    },
  },
  blogContainer: {
    maxWidth: theme.gobalMaxContentWidth,
    margin: "auto",
  },
  button: {
    backgroundColor: theme.buttonBackgroundColor,
    color: theme.buttonColor,
    textAlign: "center",
    "&:hover": {
      backgroundColor: theme.buttonBackgroundColor,
    },
    marginTop: "30px",
    marginBottom: "30px",
    cursor: "pointer",
  },
}));

const FeedItem = (props) => {
  const { count, loadMore, stepSize, index, sizeXS, sizeSM, sizeMD } = props;

  return (
    <React.Fragment>
      <Grid item xs={sizeXS} sm={sizeSM} md={sizeMD}>
        {props.children}
      </Grid>
      {index === count - stepSize && <Waypoint onEnter={() => loadMore()} />}
    </React.Fragment>
  );
};

const ArticleFeed = (props) => {
  const classes = useStyles();
  const { t } = useTranslation("common");
  const { articles, loadMore, stepSize } = props;
  const [maxPerPage, setMaxPerPage] = useState(40);
  const router = useRouter();
  const { s } = router.query;
  const searchString: string = s ? (s as string) : "";
  let perPageIncrement = 60;

  const adSlotOffet = 8;
  const ads = [];
  //   {
  //     isAd: true,
  //     id: "1",
  //     link: "https://getcyclique.com",
  //     imgBg: "/images/ads/Cyclique-Fond.jpg",
  //     imgFg: "/images/ads/Cyclique-Content.png"
  //   },
  //   {
  //     isAd: true,
  //     id: "2",
  //     link:
  //       "https://www.amazon.de/stores/node/1714914031?_encoding=UTF8&field-lbr_brands_browse-bin=Esbit&ref_=bl_dp_s_web_1714914031",
  //     imgBg: "/images/ads/Esbit-Fond.jpg",
  //     imgFg: "/images/ads/Esbit-Content.png"
  //   },
  //   {
  //     isAd: true,
  //     id: "4",
  //     link: "http://www.veloclassico.de/home/",
  //     imgBg: "/images/ads/VeloClassico-Fond.jpg",
  //     imgFg: "/images/ads/VeloClassico-Content.png"
  //   },
  //   {
  //     isAd: true,
  //     id: "3",
  //     link: "https://mecklenburger-seen-runde.de/",
  //     imgBg: "/images/ads/MSR-Fond.jpg",
  //     imgFg: "/images/ads/MSR-Content.png"
  //   }
  // ];

  const getItems = (articles) => {
    let result = articles.slice(0, maxPerPage);
    for (let i = 0; i < ads.length; i++) {
      // check length
      const insertIndex = (i + 1) * adSlotOffet + i;
      if (insertIndex >= result.length) {
        break;
      }
      result.splice(insertIndex, 0, ads[i]);
    }
    return result;
  };

  return (
    <div className={classes.blogContainer}>
      {!articles?.length ? (
          <CycleverseNoContentComp messageChildren={t('notFoundMessage')}>
            <ButtonLink
              href={`/products/search?s=${searchString}`}
              as={`/products/search?s=${searchString}`}
              buttonClassName={classes.button}
              dataTest="FindProductButton"
            >
              {t('productNotFoundButton')}
            </ButtonLink>
          </CycleverseNoContentComp>
        ) : (
      <div className={classes.root} data-test="blog-cards-container">
        <Grid container spacing={2}>
          {getItems(articles).map((item, i) => (
            <LazyLoad key={i} forceLoad={i < 6}>
              <FeedItem
                count={articles.length}
                loadMore={() => loadMore()}
                stepSize={stepSize}
                index={i}
                sizeXS={12}
                sizeSM={6}
                sizeMD={4}
              >
                {item.isAd ? <AdCard ad={item} /> : <ArticleCard article={item} forceLoad={i < 6} />}
              </FeedItem>
            </LazyLoad>
          ))}
        </Grid>
        {articles.length > maxPerPage ? (
          <Button onClick={() => setMaxPerPage(maxPerPage + perPageIncrement)}>{t("articlesLoadMore")}</Button>
        ) : (
          <div />
        )}
      </div>
      )}
    </div>
  );
};

export default ArticleFeed;
